import React from 'react'

import { withRouter } from 'react-router-dom'

import { AuthContext } from '../../main/ProvedorAutenticacao'
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { Chart } from 'primereact/chart';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import GraficoProcessoService from '../../app/service/GraficoProcessoService'
import FinanceiroService from '../../app/service/FinanceiroService'

import NavBar from '../../componentes/Navbar'
import './processo.css'
import './processo2.css'

class PainelGerencialProcesso extends React.Component {
  constructor(props) {
    super(props);

    this.graficoProcessoService = new GraficoProcessoService();
    this.financeiroService = new FinanceiroService();

    this.state = {
      meses: [],
      totalProcessos: '',
      totalAtivos: '',
      totalAtivoPercentual: '',
      totalExcluidos: '',
      totalExcluidosPercentual: '',
      totalArquivados: '',
      totalArquivadosPercentual: '',
      totalParados: '',
      totalParadosPercentual: '',
      totalProcessosPush: '',
      totalProcessosPushPercentual: '',
      statusProcessual: [],
      pieStatusProcessual: [],
      grupoTrabalho: [],
      pieGrupoTrabalho: [],
      areaAtuacao: [],
      pieAreaAtuacao: [],
      tipoAcao: [],
      pieTipoAcao: [],
      objetosAcao: [],
      pieObjetosAcao: [],
      openSpinner: false,
      detail: '',
      arquivados: [],
      cadastrados: [],
      graficoArquivadosCadastrados: null,
    }

    this.options = this.getLightTheme();
  }

  totalProcessos = (usuario) => {
    this.graficoProcessoService.totalProcessos(usuario.empresa.codigo)
      .then(response => {
        this.setState({totalProcessos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos - Total', detail:`${this.state.detail}`, life: 4000});
      })
  }

  processosAtivos = async (usuario) => {
    await this.graficoProcessoService.totalAtivos(usuario.empresa.codigo)
      .then(response => {
        this.setState({totalAtivos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos - Ativos', detail:`${this.state.detail}`, life: 4000});
      });

      const percent = parseInt(this.state.totalAtivos)/parseInt(this.state.totalProcessos) * 100;
      this.setState({totalAtivoPercentual: percent.toFixed(0)});
  }

  processosParados = async (usuario) => {
    await this.graficoProcessoService.totalParados(usuario.empresa.codigo)
      .then(response => {
        this.setState({totalParados: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos - Parados', detail:`${this.state.detail}`, life: 4000});
      });

      const percent = (parseInt(this.state.totalParados) / parseInt(this.state.totalProcessos)) * 100;
      this.setState({totalParadosPercentual: percent.toFixed(0)});
  }

  processosArquivados = async (usuario) => {
    await this.graficoProcessoService.totalArquivados(usuario.empresa.codigo)
      .then(response => {
        this.setState({totalArquivados: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos - Arquivados', detail:`${this.state.detail}`, life: 4000});
      });

      const percent = (parseInt(this.state.totalArquivados) / parseInt(this.state.totalProcessos)) * 100;
      this.setState({totalArquivadosPercentual: percent.toFixed(0)});
  }

  processosExcluidos = async (usuario) => {
    await this.graficoProcessoService.totalExcluidos(usuario.empresa.codigo)
      .then(response => {
        this.setState({totalExcluidos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos - Excluidos', detail:`${this.state.detail}`, life: 4000});
      });

      const percent = (parseInt(this.state.totalExcluidos) / parseInt(this.state.totalProcessos)) * 100;
      this.setState({totalExcluidosPercentual: percent.toFixed(0)});
  }

  processosPush = async (usuario) => {
    await this.graficoProcessoService.totalProcessosPush(usuario.empresa.codigo)
      .then(response => {
        this.setState({totalProcessosPush: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos - Push', detail:`${this.state.detail}`, life: 4000});
      });

      const percent = (parseInt(this.state.totalProcessosPush) / parseInt(this.state.totalProcessos)) * 100;
      this.setState({totalProcessosPushPercentual: percent.toFixed(0)});
  }

  statusProcessual = async (usuario) => {
    await this.graficoProcessoService.graficoStatusProcessual(usuario.empresa.codigo)
      .then(response => {
        this.setState({statusProcessual: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos - Gráficos', detail:`${this.state.detail}`, life: 4000});
      });

      //Nome
      let nomes = [];
      for(let i = 0; i < this.state.statusProcessual.length; i++) {
        nomes.push(this.state.statusProcessual[i].nome);
      }
      //Cores
      let cores = [];
      for(let i = 0; i < this.state.statusProcessual.length; i++) {
        cores.push(this.state.statusProcessual[i].cor);
      }

      //Quantidade
      let valores = [];
      for(let i = 0; i < this.state.statusProcessual.length; i++) {
        valores.push(this.state.statusProcessual[i].quantidade);
      }

      this.setState({pieStatusProcessual: {
        labels: nomes,
        datasets: [
          {
            data: valores,
            backgroundColor: cores,
          }
        ]
      }});
  }

  grupoTrabalho = async (usuario) => {
    await this.graficoProcessoService.graficoGrupoTrabalho(usuario.empresa.codigo)
      .then(response => {
        this.setState({grupoTrabalho: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos - Gráficos', detail:`${this.state.detail}`, life: 4000});
      });

      //Nome
      let nomes = [];
      for(let i = 0; i < this.state.grupoTrabalho.length; i++) {
        nomes.push(this.state.grupoTrabalho[i].nome);
      }
      //Cores
      let cores = [];
      for(let i = 0; i < this.state.grupoTrabalho.length; i++) {
        cores.push(this.state.grupoTrabalho[i].cor);
      }

      //Quantidade
      let valores = [];
      for(let i = 0; i < this.state.grupoTrabalho.length; i++) {
        valores.push(this.state.grupoTrabalho[i].quantidade);
      }

      this.setState({pieGrupoTrabalho: {
        labels: nomes,
        datasets: [
          {
            data: valores,
            backgroundColor: cores,
          }
        ]
      }});
  }

  areaAtuacao = async (usuario) => {
    await this.graficoProcessoService.graficoAreaAtuacao(usuario.empresa.codigo)
      .then(response => {
        this.setState({areaAtuacao: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos - Gráficos', detail:`${this.state.detail}`, life: 4000});
      });

      //Nome
      let nomes = [];
      for(let i = 0; i < this.state.areaAtuacao.length; i++) {
        nomes.push(this.state.areaAtuacao[i].nome);
      }
      //Cores
      let cores = [];
      for(let i = 0; i < this.state.areaAtuacao.length; i++) {
        cores.push(this.state.areaAtuacao[i].cor);
      }

      //Quantidade
      let valores = [];
      for(let i = 0; i < this.state.areaAtuacao.length; i++) {
        valores.push(this.state.areaAtuacao[i].quantidade);
      }

      this.setState({pieAreaAtuacao: {
        labels: nomes,
        datasets: [
          {
            data: valores,
            backgroundColor: cores,
          }
        ]
      }});
  }

  tipoAcao = async (usuario) => {
    await this.graficoProcessoService.graficoTipoAcao(usuario.empresa.codigo)
      .then(response => {
        this.setState({tipoAcao: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos - Gráficos', detail:`${this.state.detail}`, life: 4000});
      });

      //Nome
      let nomes = [];
      for(let i = 0; i < this.state.tipoAcao.length; i++) {
        nomes.push(this.state.tipoAcao[i].nome);
      }
      //Cores
      let cores = [];
      for(let i = 0; i < this.state.tipoAcao.length; i++) {
        cores.push(this.state.tipoAcao[i].cor);
      }

      //Quantidade
      let valores = [];
      for(let i = 0; i < this.state.tipoAcao.length; i++) {
        valores.push(this.state.tipoAcao[i].quantidade);
      }

      this.setState({pieTipoAcao: {
        labels: nomes,
        datasets: [
          {
            data: valores,
            backgroundColor: cores,
          }
        ]
      }});
  }

  objetosAcao = async (usuario) => {
    await this.graficoProcessoService.graficoObjetosAcao(usuario.empresa.codigo)
      .then(response => {
        this.setState({objetosAcao: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos - Gráficos', detail:`${this.state.detail}`, life: 4000});
      });

      //Nome
      let nomes = [];
      for(let i = 0; i < this.state.objetosAcao.length; i++) {
        nomes.push(this.state.objetosAcao[i].nome);
      }
      //Cores
      let cores = [];
      for(let i = 0; i < this.state.objetosAcao.length; i++) {
        cores.push(this.state.objetosAcao[i].cor);
      }

      //Quantidade
      let valores = [];
      for(let i = 0; i < this.state.objetosAcao.length; i++) {
        valores.push(this.state.objetosAcao[i].quantidade);
      }

      this.setState({pieObjetosAcao: {
        labels: nomes,
        datasets: [
          {
            data: valores,
            backgroundColor: cores,
          }
        ]
      }});
  }
  
  consultarPainel = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.listarMeses();
    await this.totalProcessos(usuarioLogado);
    await this.processosAtivos(usuarioLogado);
    await this.processosExcluidos(usuarioLogado);
    await this.processosParados(usuarioLogado);
    await this.processosArquivados(usuarioLogado);
    await this.processosPush(usuarioLogado);
    await this.statusProcessual(usuarioLogado);
    await this.grupoTrabalho(usuarioLogado);
    await this.areaAtuacao(usuarioLogado);
    await this.tipoAcao(usuarioLogado);
    await this.objetosAcao(usuarioLogado);
    await this.consultarArquivadosCadastrados(usuarioLogado)
  }

  async componentDidMount() {
    this.setState({openSpinner: true});
    await this.consultarPainel();
    this.setState({openSpinner: false});
  }

  consultarGraficoArquivados = async (usuario) => {
    const dataAtual = new Date();
    const anoAtual = dataAtual.getFullYear();
    var dataFormatadaInicial =  anoAtual+"-01-01";
    var dataFormatadaFinal =  anoAtual+"-12-31";
    await this.graficoProcessoService.graficoProcessoArquivado(usuario.empresa.codigo, dataFormatadaInicial, dataFormatadaFinal)
      .then(response => {
        this.setState({arquivados: response.data});
      }).catch(error => {
        console.log('Cadastrados', error);
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos - Gráficos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarGraficoCadastrados = async (usuario) => {
    const dataAtual = new Date();
    const anoAtual = dataAtual.getFullYear();
    var dataFormatadaInicial =  anoAtual+"-01-01";
    var dataFormatadaFinal =  anoAtual+"-12-31";
    await this.graficoProcessoService.graficoProcessoMes(usuario.empresa.codigo, dataFormatadaInicial, dataFormatadaFinal)
      .then(response => {
        this.setState({cadastrados: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos - Gráficos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarMeses = async () => {
    await this.financeiroService.listarMeses()
      .then(response => {
        this.setState({meses: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Financeiro - Meses', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarArquivadosCadastrados = async (usuario) => {
    await this.consultarGraficoCadastrados(usuario);
    await this.consultarGraficoArquivados(usuario);
    
    let nomesMeses = [];

    for(let k = 0; k < this.state.meses.length; k++) {
      nomesMeses.push(this.state.meses[k].mes);
    }
    
    let arquivados = [];
    for(let i = 0; i < this.state.arquivados.length; i++) {
      console.log('Está entrando aqui')
      arquivados.push(this.state.arquivados[i].total);
    }

    let cadastrados = [];
    for(let j = 0; j < this.state.cadastrados.length; j++) {
      cadastrados.push(this.state.cadastrados[j].total);
    }

    await this.setState({basicData2: {
      labels: nomesMeses,
      datasets: [
        {

          label: 'Cadastrados',
          backgroundColor: '#008000',
          data: cadastrados
        },
        {

          label: 'Arquivados',
          backgroundColor: '#cccccc',
          data: arquivados
        }
      ]
    }})
  }

  getLightTheme() {
    let basicOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    let horizontalOptions = {
        indexAxis: 'y',
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    let stackedOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            tooltips: {
                mode: 'index',
                intersect: false
            },
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                stacked: true,
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                stacked: true,
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    let multiAxisOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057',
                }
            },
            tooltips: {
                mode: 'index',
                intersect: true
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                type: 'linear',
                display: true,
                position: 'left',
                ticks: {
                    min: 0,
                    max: 100,
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y1: {
                type: 'linear',
                display: true,
                position: 'right',
                grid: {
                    drawOnChartArea: false,
                    color: '#ebedef'
                },
                ticks: {
                    min: 0,
                    max: 100,
                    color: '#495057'
                }
            }
        }
    };

    return {
        basicOptions,
        horizontalOptions,
        stackedOptions,
        multiAxisOptions
    }
  }

  render() {
    const { basicOptions, horizontalOptions, multiAxisOptions, stackedOptions } = this.options;
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="content-wrapper">
          <div className="container-fluid">
            <section className="content-header">
              <div className="card card-primary card-outline">
                <div className="card-header">
                  <h3 className="card-title">
                    <i className="fas fa-users"></i>
                    <span> Painel Gerencial Processos</span>
                  </h3>
                </div>

                <div className="card-body">
                  <br></br>
                  <div className="row">
                    <div className="col-sm-2">
                      <div className="formGroup">
                        <div className="card2 blue">
                          <h3>Processos</h3>
                          <p>{this.state.totalProcessos} - (100%)</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="formGroup">
                        <div className="card2 blue">
                          <h3>Ativos</h3>
                          <p>{this.state.totalAtivos} - ({this.state.totalAtivoPercentual}%)</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="formGroup">
                        <div className="card2 blue">
                          <h3>90 Dias</h3>
                          <p>{this.state.totalParados} - ({this.state.totalParadosPercentual}%)</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="formGroup">
                        <div className="card2 blue">
                          <h3>Arquivados</h3>
                          <p>{this.state.totalArquivados} - ({this.state.totalArquivadosPercentual}%)</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="formGroup">
                        <div className="card2 blue">
                          <h3>Excluídos</h3>
                          <p>{this.state.totalExcluidos} - ({this.state.totalExcluidosPercentual}%)</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="formGroup">
                        <div className="card2 blue">
                          <h3>Push</h3>
                          <p>{this.state.totalProcessosPush} - ({this.state.totalProcessosPushPercentual}%)</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br></br>
                  <br></br>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="formGroup">
                        <div className="card flex justify-content-center" style={{alignItems: 'center'}}>
                            <h5>Grupo de Trabalho</h5>
                            <Chart type="doughnut" data={this.state.pieGrupoTrabalho} style={{ position: 'relative', width: '48%' }} />
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="formGroup">
                        <div className="card flex justify-content-center" style={{alignItems: 'center'}}>
                            <h5>Status Processual</h5>
                            <Chart type="pie" data={this.state.pieStatusProcessual} style={{ position: 'relative', width: '48%' }} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="formGroup">
                        <div className="card flex justify-content-center" style={{alignItems: 'center'}}>
                            <h5>Área de Atuação</h5>
                            <Chart type="polarArea" data={this.state.pieAreaAtuacao} style={{ position: 'relative', width: '48%' }} />
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="formGroup">
                        <div className="card flex justify-content-center" style={{alignItems: 'center'}}>
                            <h5>Objetos de Ação</h5>
                            <Chart type="doughnut" data={this.state.pieObjetosAcao} style={{ position: 'relative', width: '48%' }} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="formGroup">
                        <div className="card flex justify-content-center" style={{alignItems: 'center', height: '38%'}}>
                            <h5>Cadastrados x Arquivados</h5>
                            <Chart type="bar" data={this.state.basicData2} options={basicOptions} style={{ position: 'relative', width: '100%' }} />
                        </div>  
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="formGroup">
                        <div className="card flex justify-content-center" style={{alignItems: 'center'}}>
                            <h5>Tipos de Ação</h5>
                            <Chart type="pie" data={this.state.pieTipoAcao} style={{ position: 'relative', width: '48%' }} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </>
    )
  }
}
PainelGerencialProcesso.contextType = AuthContext;
export default withRouter(PainelGerencialProcesso)
